// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'shield';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2 3.257V8.67a8.41 8.41 0 0 0 1.502 4.793 8.537 8.537 0 0 0 3.977 3.11l.748.284c.497.19 1.049.19 1.546 0l.748-.285a8.537 8.537 0 0 0 3.977-3.109A8.41 8.41 0 0 0 16 8.671V3.257a1.05 1.05 0 0 0-.623-.969A15.71 15.71 0 0 0 9 1.001a15.709 15.709 0 0 0-6.377 1.287A1.065 1.065 0 0 0 2 3.257z'
  />
);

export const viewBox = '0 0 18 18';
